<template>
    <div v-if="loadedContracts">
        <!--    <b-alert show variant="light" class="alert alert-elevate">-->
        <!--      <div class="alert-icon">-->
        <!--        <i class="flaticon-warning kt-font-brand"></i>-->
        <!--      </div>-->
        <!--      <div class="alert-text">-->
        <!--        <b>Data tables</b> The <code>v-data-table</code> component is used for-->
        <!--        displaying tabular data. Features include sorting, searching,-->
        <!--        pagination, inline-editing, header tooltips, and row selection.-->
        <!--        <a-->
        <!--          class="kt-link kt-link&#45;&#45;brand kt-font-bold"-->
        <!--          href="https://vuetifyjs.com/en/components/data-tables"-->
        <!--          target="_blank"-->
        <!--        >-->
        <!--          See documentation.-->
        <!--        </a>-->
        <!--      </div>-->
        <!--    </b-alert>-->

        <div>
            <div class="row">
                <div class="col-md-12">
                    <!--begin:: Widgets/Activity-->
                    <KTPortlet
                            v-bind="{
            }"
                    >
                        <template v-slot:body>
                            <b-button-toolbar
                                    aria-label="Toolbar with button groups and input groups"
                            >

                                <b-button-group size="sm" class="mr-1" >
                                    <!--                  <b-button :to="{'name':'document-edit'}" class="mr-2 btn-primary">Nuovo documento</b-button>-->
                                    <!--<v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>-->
                                    <b-form-select
                                            class="mb-2 mr-sm-2 mb-sm-0"
                                            v-model="filter.contract"
                                            :options="filteroptions.contract"
                                            id="inline-form-custom-select-pref"
                                            required
                                            @change="reloadList()"
                                    >
                                        <template v-slot:first>
                                            <option :value="null">Filtra documento</option>
                                        </template>
                                    </b-form-select>

                                </b-button-group>
                                <b-button-group size="sm" class="ml-auto"  v-if="showDownloadCSVButton">
                                    <vc-date-picker v-model="rangeExport" is-range
                                                    class="mr-1">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <div class="flex justify-center items-center">
                                                Da
                                                <input style="max-width: 114px;"
                                                       :value="inputValue.start"
                                                       v-on="inputEvents.start"
                                                       class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                                />
                                                A
                                                <input style="max-width: 114px;"
                                                       :value="inputValue.end"
                                                       v-on="inputEvents.end"
                                                       class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                                />
                                            </div>
                                        </template>
                                    </vc-date-picker>
                                    <b-button  v-on:click="downloadCSV()" class="mr-3" variant="outline-primary">Scarica CSV</b-button>
                                </b-button-group>

                            </b-button-toolbar>
                        </template>
                    </KTPortlet>
                    <!--end:: Widgets/Activity-->
                </div>

            </div>
        </div>
        <div v-permission="'contract.view'">
            <div class="row">
                <div class="col-md-12">
                    <!--begin:: Widgets/Activity-->
                    <KTPortlet
                            v-bind="{
            }" v-bind:class="{ 'kt-spinner-f': loading }"
                    >
                        <template v-slot:body>

                            <v-card>
                                <v-card-title>
                                    Elenco
                                    <v-spacer></v-spacer>
                                    <div class="v-input mr-3" style="display:none">
                                        <vc-date-picker v-model="range" is-range :input-debounce="500"
                                                        style="    align-self: flex-end;">
                                            <template v-slot="{ inputValue, inputEvents }">
                                                <div class="flex justify-center items-center">
                                                    Da
                                                    <input style="max-width: 114px;"
                                                           :value="inputValue.start"
                                                           v-on="inputEvents.start"
                                                           class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                                    />
                                                    A
                                                    <input style="max-width: 114px;"
                                                           :value="inputValue.end"
                                                           v-on="inputEvents.end"
                                                           class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                                    />
                                                </div>
                                            </template>
                                        </vc-date-picker>
                                        <v-text-field style="max-width: 100px;" class="ml-3"
                                                      type="number"
                                                      v-model="searchid"
                                                      label="ID"
                                                      single-line
                                                      hide-details
                                                      v-on:input="deReloadList()"
                                        ></v-text-field>
                                    </div>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Cerca"
                                            single-line
                                            hide-details
                                            v-on:input="deReloadList()"
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                        v-model="selected"
                                        :headers="headers"
                                        :items="items"
                                        :single-select="singleSelect"
                                        :sort-by="['id']"
                                        :sort-desc="[true]"
                                        multi-sortNO
                                        item-key="id"
                                        show-selectNO
                                        class="elevation-1 table-force-width"
                                        :search="search"
                                        :footer-props="footerProps"
                                        :server-items-length="pagination.totalNumberOfItems"
                                        @update:page="paginate"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <template v-if="statusesloaded">
                                          <span v-if="showEdit()">
                                            <b-form-select
                                                class="mb-2 mr-sm-2 mb-sm-0"
                                                v-model="item.status"
                                                :options="statusesSelect"
                                                id="inline-form-custom-select-pref"
                                                required
                                                @change="changeStatus(item)"
                                            >
                                                <template v-slot:first>
<!--                                                    <option :value="null">Filtra documento</option>-->
                                                </template>
                                            </b-form-select>
                                          </span>
                                          <span v-if="!showEdit()">{{statuses[item.status]}}</span>
                                        </template>
                                    </template>
                                    <template v-slot:item.created_at="{ item }">
                                        <span>{{item.created_at | formatDate}}</span>
                                    </template>
                                    <!--                  <template v-slot:item.updated_at="{ item }">-->
                                    <!--                    <span>{{item.updated_at | formatDate}}</span>-->
                                    <!--                  </template>-->
                                    <!--                                    <template v-slot:top>
                                                                            <v-switch v-model="singleSelect" label="Single select" class="pa-3"></v-switch>
                                                                        </template>-->
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon v-if="!isDraft" v-permission="'contract.fill'"
                                                small
                                                class="mr-2 vaction"
                                                @click="viewSubmission(item)"
                                        >
                                            mdi-eye
                                        </v-icon>
                                        <v-icon v-if="!isDraft && showEdit()"
                                                small
                                                class="mr-2 vaction"
                                                @click="editSubmission(item)"
                                        >
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon v-if="isDraft"  v-permission="'contract.fill'"
                                                small
                                                class="mr-2 vaction"
                                                @click="viewSubmission(item)"
                                        >
                                            mdi-pencil
                                        </v-icon>
                                        <a v-if="!isDraft && item.status === 'SIGNED'" class="vactiona"
                                           v-bind:href="item.downloadUrl" target="_blank">
                                            <v-icon v-permission="'contract.fill'"
                                                    small
                                                    class="mr-2 vaction"
                                            >
                                                mdi-download
                                            </v-icon>
                                        </a>
                                      <div v-if="isDraft && showDelete()" class="inlineblock"><click-confirm>
                                        <v-icon
                                                 small
                                                 @click="deleteDraft(item)"
                                        >
                                          mdi-delete
                                        </v-icon>
                                      </click-confirm></div>
                                      <div v-if="!isDraft && showDelete()" class="inlineblock"><click-confirm>
                                        <v-icon
                                                 small
                                                 @click="deleteSubmission(item)"
                                        >
                                          mdi-delete
                                        </v-icon>
                                      </click-confirm></div>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </template>
                    </KTPortlet>
                    <!--end:: Widgets/Activity-->
                </div>

            </div>
        </div>

    </div>
</template>
<style>
    .table-force-width.v-data-table__wrapper table{
        max-width: 100%;
        table-layout: fixed;
    }
    .table-force-width.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
    .table-force-width.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
    .table-force-width.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
    .table-force-width.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
    .table-force-width.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
    .table-force-width.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
        padding: 0 8px;
    }

</style>
<script>
    import {SET_BREADCRUMB} from "@/store/breadcrumbs.module";
    import KTPortlet from "@/views/partials/content/Portlet.vue";
    import ApiService from "@/common/api.service";
    import JwtService from "@/common/jwt.service";
    import {API_URL} from "@/common/config";
    import moment from 'moment';
    import UserService from "../../../common/user.service";

    export default {
        data() {
            return {
                loading: false,
                singleSelect: false,
                isDraft:false,
                showAgentColumns:false,
                showDownloadCSVButton:false,
                selected: [],
                search: '',
                searchid: '',
                contractNames:{},
                loadedContracts:false,
                headers: null,
                statusesloaded:0,
                statuses:[],
                statusesSelect:[],
                range: {
                    start: null,
                    end: null
                },
                rangeExport: {
                    start: null,
                    end: null
                },
                pagination: {
                    //descending: !!this.$route.query.desc,
                    //sortBy: this.$route.query.orderby || 'name',
                    rowsPerPage: 100,
                    //listSize: [10, 25, 50, 100],
                    listSize: [100],
                    page: 1,
                    totalNumberOfItems: 0,
                },
                footerProps: {'items-per-page-options': [100]},
                filteroptions: {
                    contract: []
                },
                filter: {
                    contract: null
                },
                items: [],
            }
        },
        watch: {
            range: function () {
                this.reloadList();

            }
        },
        components: {
            KTPortlet
        },
        mounted() {



            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Documenti", route: "/document"},
                {title: "Storico invii", route: "history"}
            ]);

        },

        created() {
            this.showAgentColumns = this.shouldShowAgentColumns();
            this.isDraft = this.$route.name === 'document-history-drafts';
            if(this.isDraft) {
                this.range.start = moment().subtract(1, 'months').toDate();
                this.range.end = moment().toDate();
            }

            this.loadOptions();
        },

        methods: {
            showEdit(){
              return UserService.isSuperDebugUser() || this.$store.getters.currentUser.is_organization_admin;
              // return this.$store.getters.currentUser.is_organization_admin || UserService.hasPermission(['contract.edit'])
            },
            showDelete(){
              return UserService.isSuperDebugUser() ||  this.$store.getters.currentUser.is_organization_admin;
              // return this.$store.getters.currentUser.is_organization_admin || UserService.hasPermission(['contract.delete'])
            },
            shouldShowAgentColumns() {
                return (this.$store.getters.currentUser.is_organization_admin || ![3,5,6].includes(this.$store.getters.currentUser.organization_id));
            },
            loadOptions() {
                ApiService.get('lists/sw/status')
                    .then(({data}) => {
                      data.forEach((x) => {
                        this.statuses[x.id] = x.label;
                        this.statusesSelect.push({value: x.id, text: x.label});
                      });
                      this.statusesloaded=1;
                    })
                    .catch(({response}) => {
                        //context.commit(SET_ERROR, response.data.errors);
                    });
                ApiService.get('contracts')
                    .then(({data}) => {
                        data.rows.forEach((x) => {
                            this.contractNames[parseInt(x.id)] = x.label;
                            this.filteroptions.contract.push({value: x.id, text: x.id + ' - ' + x.label});
                        });

                        this.loadedContracts = true;
                        this.initialize();
                    })
                    .catch(({response}) => {
                        //context.commit(SET_ERROR, response.data.errors);
                    });
            },
            paginate(val) {
                this.pagination.page = val;
                this.reloadList();
            },
            deReloadList() {
                if (window.search_timeout) clearTimeout(window.search_timeout);
                var that = this;
                window.search_timeout = setTimeout(function () {
                    that.reloadList();
                }, 800);
            },
            reloadList() {
                // console.log('reloadinglist', this.range);
                this.loading = true;
                const params = {
                    page: this.pagination.page,
                };
                // if(UtilService.isNumeric()){
                //
                // }
                if (this.searchid) {
                    params.id = parseInt(this.searchid);
                }
                if (this.range.start) {
                    params.date_from = moment(this.range.start).format('YYYY-MM-DD');
                }
                if (this.range.end) {
                    params.date_to = moment(this.range.end).format('YYYY-MM-DD');
                }


                const callbackList = this.isDraft ?
                        ApiService.get('drafts', '?' + (new URLSearchParams(params)).toString()) :
                        ApiService.get('submissions', '?' + (new URLSearchParams(params)).toString());

                callbackList
                    .then(({data}) => {

                        this.pagination.totalNumberOfItems = data.count;
                        this.items = data.rows.filter((x) => {
                            if (this.filter.contract && this.filter.contract != x.contract_configuration_id) {
                                return false;
                            }

                            // Try to get data from submission
                            let holderData = [];
                            let additionalInfo = this.isDraft ? JSON.parse(x.data).data : x.submission;

                            if (additionalInfo && additionalInfo.submission) {
                                if (additionalInfo.submission.ragione_sociale) {
                                    holderData.push(additionalInfo.submission.ragione_sociale);
                                } else {
                                    if (additionalInfo.submission.cognome) {
                                        holderData.push(additionalInfo.submission.cognome);
                                    }
                                    if (additionalInfo.submission.nome) {
                                        holderData.push(additionalInfo.submission.nome);
                                    }
                                }
                            }
                            x._holder = holderData.join(' ');

                            // Add more info if draft
                            if(this.isDraft){
                                if(!x.email && additionalInfo.submission && additionalInfo.submission.email_intestatario){
                                    x.email = additionalInfo.submission.email_intestatario;
                                }
                                if(!x.cellulare && additionalInfo.submission && additionalInfo.submission.cellulare_intestatario){
                                    x.phone = additionalInfo.submission.cellulare_intestatario;
                                }
                            }


                            // Text filter
                            if (this.search && (!x.id || x.id != this.search) && (!x._holder || x._holder.toLowerCase().indexOf(this.search.toLowerCase()) === -1) && (!x.email || x.email.toLowerCase().indexOf(this.search.toLowerCase()) === -1) && (!x.phone || x.phone.indexOf(this.search) === -1) && (!x.random_code || x.random_code.toLowerCase().indexOf(this.search.toLowerCase()) === -1) && (!x.codice_agente || x.codice_agente.toLowerCase().indexOf(this.search.toLowerCase()) === -1)) {
                                return false;
                            }


                            x.downloadUrl = API_URL + '/submissions/' + x.id + '?jwt=' + JwtService.getToken() + '&pdf=1';

                            x.documentname = this.contractNames[parseInt(x.contract_configuration_id)];
                            // console.log(this.contractNames,x.documentname);
                            // x.documentname = this.contractNames[x.contract_template_id];
                            return true;
                        });
                        this.loading = false;
                    })
                    .catch(({response}) => {
                        //context.commit(SET_ERROR, response.data.errors);
                    });
            },
            initialize() {



                this.headers =
                    this.showAgentColumns ? (
                        this.isDraft ?
                            [
                                {text: 'ID', value: 'id'},
                                {text: 'Intestatario', value: '_holder'},
                                {text: 'Email', value: 'email'},
                                {text: 'Phone', value: 'phone'},
                                // {text: 'User', value: 'user_id'},
                                {text: 'User', value: 'user.email'},
                                {text: 'Creato il', value: 'created_at'},

                            ]
                            :
                            [
                                {text: 'ID', value: 'id'},
                                {text: 'Intestatario', value: '_holder'},
                                {text: 'Email', value: 'email'},
                                {text: 'Cellulare', value: 'phone'},
                                {text: 'Stato', value: 'status'},
                                // {text: 'Utente', value: 'user_id'},
                                {text: 'Utente', value: 'user.email'},
                                {text: 'Creato il', value: 'created_at'},

                            ]
                        ):(
                    this.isDraft ?
                        [
                          {text: 'ID', value: 'id'},
                          {text: 'Intestatario', value: '_holder'},
                          {text: 'Email', value: 'email'},
                          {text: 'Phone', value: 'phone'},
                          // {text: 'User', value: 'user_id'},
                          {text: 'User', value: 'user.email'},
                          {text: 'Creato il', value: 'created_at'},

                        ]
                        :
                        [
                          {text: 'ID', value: 'id'},
                          {text: 'Intestatario', value: '_holder'},
                          {text: 'Email', value: 'email'},
                          {text: 'Cellulare', value: 'phone'},
                          {text: 'Stato', value: 'status'},
                          // {text: 'Utente', value: 'user_id'},
                          {text: 'Utente', value: 'user.email'},
                          {text: 'Creato il', value: 'created_at'},

                        ]
                    );

                if (this.$route.query.filter_contract) {
                    this.filter.contract = this.$route.query.filter_contract;
                }

                // if(UserService.hasPermission(['contract.edit'])){
                this.headers.push({text: 'Actions', value: 'actions', sortable: false, width: '150px'});
                // }
                this.reloadList();

                this.showDownloadCSVButton = this.showDownloadCSV();

            },

            // editSubmission (item) {
            //   this.$router.push({ name: "document-submission-edit", 'params':{'id':item.id} });
            // },
            viewSubmission(item) {
                this.$router.push({
                    name: this.isDraft ? "document-draft-view" : "document-submission-view",
                    'params': {'id': item.contract_configuration_id, 'sid': item.id}
                });
            },

            editSubmission(item) {
                this.$router.push({
                    name: "document-submission-edit",
                    'params': {'id': item.contract_configuration_id, 'sid': item.id}
                });
            },

            changeStatus(item){
              console.log(item);
              ApiService.post('submissions/status/'+item.id,{'status':item.status}).then(() => {
                // this.reloadList();
              });
            },

            deleteDraft(item) {
                ApiService.delete('drafts/'+item.id,{'id':item.id}).then(() => this.reloadList());
            },

            deleteSubmission(item) {
                ApiService.post('submissions/delete/'+item.id,{'id':item.id}).then(() => this.reloadList());
            },
            showDownloadCSV(){
                return UserService.isSuperDebugUser() || (this.$store.getters.currentUser.is_organization_admin && [1,7,8,9,10,11,12,13,14,16].includes(this.$store.getters.currentUser.organization_id));
            },
            downloadCSV() {
                const params = {};
                params.jwt = JwtService.getToken();
                if (this.rangeExport.start) {
                    params.date_from = moment(this.rangeExport.start).format('YYYY-MM-DD');
                }
                if (this.rangeExport.end) {
                    params.date_to = moment(this.rangeExport.end).format('YYYY-MM-DD');
                }
                if (this.filter.contract) {
                    params.contract_configuration_id = this.filter.contract;
                }

                window.open(
                    API_URL+'/exports/export-csv?'+(new URLSearchParams(params)),
                    '_blank' // <- This is what makes it open in a new window.
                );
            }


        },
    };
</script>
